<template>
  <transition name="fade">
    <div class="level3-landingpage-container">
      <div class="lv3-title-text">Tambah Pemilik Saham Data</div>
      <div class="lv3-edit-form" style="overflow-y: auto !important">
        <div class="edit-form-wrapper">
          <div>Nama</div>
          <input
            class="lv3-input-text"
            type="text"
            v-model="namaPemilikSaham"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
          />
        </div>
        <div class="edit-form-wrapper">
          <div>% Saham</div>
          <input
            class="lv3-input-text"
            type="number"
            v-model="sahamPemilikSaham"
          />
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="submitForm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['propsData'],
  data() {
    return {
      jabatan: '',
      nama: '',
      phoneNumber: '',
      email: '',
      totalSaham: 0,
    }
  },
  computed: {
    namaPemilikSaham: {
      get() {
        return this.$store.state.landingpage.namaPemilikSaham
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'namaPemilikSaham',
          value: newValue,
        })
      },
    },
    sahamPemilikSaham: {
      get() {
        return this.$store.state.landingpage.sahamPemilikSaham
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'sahamPemilikSaham',
          value: Number(newValue),
        })
      },
    },
  },
  methods: {
    submitForm() {
      if (this.checkForm()) {
        this.confirm()
      }
    },
    checkForm() {
      let arr = [
        [
          this.namaPemilikSaham,
          'Silahkan mengisi Nama Pemilik Saham dengan benar.',
        ],
        [this.checkTotalSaham(), 'Total Saham lebih dari 100%'],
      ]

      return this.multiCustomConditions(arr)
    },
    closeModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPemilikSaham',
        value: false,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editPemilikSaham',
        value: false,
      })
    },
    checkTotalSaham() {
      if (
        this.$get(this.$store, 'state.landingpage.totalSaham') &&
        Number(this.$get(this.$store, 'state.landingpage.totalSaham')) +
          Number(this.sahamPemilikSaham) >
          100
      ) {
        return false
      } else {
        return true
      }
    },
    confirm() {
      if (this.$store.state.landingpage.addPemilikSaham) {
        let pemilikSahamData = {
          id: this.$store.state.landingpage.pemilikSahamIndex + 1,
          nama: this.$store.state.landingpage.namaPemilikSaham,
          saham: this.$store.state.landingpage.sahamPemilikSaham,
        }

        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'pemilikSahamList',
          value: pemilikSahamData,
          operation: 'add',
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'pemilikSahamIndex',
          value: pemilikSahamData.id + 1,
        })
      } else if (this.$store.state.landingpage.editPemilikSaham) {
        let pemilikSahamData = {
          id: this.$store.state.landingpage.idPemilikSaham,
          nama: this.$store.state.landingpage.namaPemilikSaham,
          saham: this.$store.state.landingpage.sahamPemilikSaham,
        }
        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'pemilikSahamList',
          value: pemilikSahamData,
          operation: 'edit',
        })
      }

      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaPemilikSaham',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'sahamPemilikSaham',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPemilikSaham',
        value: false,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editPemilikSaham',
        value: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
